export enum Atributo {
  forca = "forca",
  destreza = "destreza",
  constituicao = "constituicao",
  inteligencia = "inteligencia",
  sabedoria = "sabedoria",
  carisma = "carisma",
}
